angular.module('leanlaw').controller('ConflictEntryViewCtrl', ['$scope', '$state', '$stateParams', 'leanLawApi', function ($scope, $state, $stateParams, leanLawApi) {
  leanLawApi.getEntry({
    id: $stateParams.id
  }).then(entry => {
    $scope.entry = entry;
  });
}]);